
import React, { Fragment, Suspense, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useTable } from "react-table";
import { Segment, Table } from "semantic-ui-react";
import { useApplicationConfiguration } from "../../../configuration/ConfigurationContext";
import { IPagination } from "../../../interfaces/common/IPagination";
import { IAuditItem } from "../../../interfaces/IAuditItem";
import createColumns from "./TableColumns";
import TablePagination from "./TablePagination";
import "./_AuditsTable.less";

interface AuditsTableProps {
    columns: any;
    data: IAuditItem[];
    pagination: IPagination;
    goToPage: (page: number) => void;
};

const AuditsTableContent: React.FC<AuditsTableProps> = ({
    data,
    columns,
    pagination,
    goToPage,
}) => {

    const table = useTable({ columns, data });

    const {
        getTableProps,
        getTableBodyProps,

        headerGroups,
        prepareRow,

        rows
    } = table;

    const pages = (pagination.totalItems || 0) / pagination.pageSize

    return (
        <Fragment>
            <Suspense fallback={<Segment loading basic />}>
                <Table
                    {...getTableProps()}
                    fixed={false}
                    basic="very"
                    className="tablet stackable AuditsTable-table"
                >

                    <Table.Header className="mobile hidden">
                        {headerGroups.map((headerGroup: any) => (
                            <Table.Row {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((header: any) => (
                                    <Table.HeaderCell  {...header.getHeaderProps()}>
                                        {header.render("Header")}
                                    </Table.HeaderCell>
                                ))}
                            </Table.Row>
                        ))}
                    </Table.Header>

                    <Table.Body {...getTableBodyProps()}>
                        {rows.map((row: any, i: number) => {
                            prepareRow(row);
                            const rowProps = row.getRowProps()
                            return (
                                <Table.Row className="AuditsTable-tbody-row" {...rowProps} key={rowProps.key + row.original.id}>
                                    {row.cells.map((cell: any) => (
                                        <Table.Cell  {...cell.getCellProps()}>
                                            {cell.render("Cell")}
                                        </Table.Cell>
                                    ))}
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>


                {pages > 1 && (
                    <TablePagination
                        activePage={pagination.page}
                        onPageChange={goToPage}
                        ellipsisItem={null}
                        firstItem={null}
                        lastItem={null}

                        siblingRange={1}
                        totalPages={(pagination.totalItems || 0) / pagination.pageSize}
                        size="small"
                        basic="very"
                    />
                )}

            </Suspense>
        </Fragment>
    );
};




interface AuditsTable {
    items: IAuditItem[];
    pagination: IPagination;
    goToPage: (page: number) => void;
};

export const AuditsTable: React.FC<AuditsTable> = ({ items, pagination, goToPage }) => {
    const { t } = useTranslation();
    const { components: { LocationName, PersonName }, showAuditSummary } = useApplicationConfiguration()
    const columns = useMemo(() => createColumns(t, LocationName, PersonName, showAuditSummary), [t]); // eslint-disable-line
    const pageChange = useCallback(goToPage, [])
    return (
        <AuditsTableContent
            pagination={pagination}
            columns={columns}
            data={items}
            goToPage={pageChange}
        />
    )
}
